import { createRouter, createWebHistory } from '@ionic/vue-router';
import TabsPage from '../views/TabsPage.vue'

const routes = [
  {
    path: '/',
    redirect: '/tabs/home'
  },
  {
    path: '/tabs/',
    component: TabsPage,
    children: [
      {
        path: '',
        redirect: '/tabs/home'
      },
      {
        path: 'settings',
        component: () => import('@/views/TabSettingsPage.vue')
      },
      {
        path: 'home',
        component: () => import('@/views/TabHomePage.vue')
      },
      {
        path: 'walks',
        component: () => import('@/views/TabWalksPage.vue')
      },
      {
        path: 'events',
        component: () => import('@/views/TabEventsPage.vue')
      },
      {
        path: 'join',
        component: () => import('@/views/TabJoinPage.vue')
      },
      {
        path: '/walk/:id',
        component: () => import('@/views/Walk.vue')
      },
      {
        path: '/event/:id',
        component: () => import('@/views/Event.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
